import React, { useState, useEffect } from "react";
import { Box, createTheme, Stack, Typography, Grid } from "@mui/material";
import { useStateValue } from "../../StateProvider";
import { useNavigate, useParams } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import axios from "axios";

const PressReleases = () => {
  const navigate = useNavigate();
  const [pressReleases, setPressReleases] = useState([]);
  const [{ token }] = useStateValue();
  useEffect(() => {
    axios
      .get(
        `https://cloud.iexapis.com/stable/time-series/news?range=1m&limit=100&token=${token}`
      )
      .then((res) => {
        console.log(res.data);
        setPressReleases(res?.data);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <Box sx={{ padding: "20px", height: "98vh", overflowY: "scroll" }}>
      <Box
        sx={{
          padding: { xs: "10px 20px", sm: "10px 20px" },
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Typography
          sx={{
            fontSize: "1.5rem",
            fontFamily: "public sans",
            fontWeight: "500",
            color: "fontPrimaryColor.main",
            textTransform: "uppercase",
            marginLeft: { xs: "10px", sm: "0" },
            wordSpacing: "5px",
          }}
        >
          Press Releases
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "bgPrimary.main",
          minHeight: "60vh",
          marginTop: "30px",
          borderRadius: "8px",
          padding: "20px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "30px" }}>
          {pressReleases?.map((p) => (
            <Box>
              {/* <img
                src={p?.img ? p?.image : p?.imageUrl}
                style={{ width: "50px", height: "50px" }}
              /> */}
              <Box sx={{ fontSize: "1rem", fontFamily: "public sans" }}>
                <a style={{ color: "#2d79db" }} href={p?.url} target="_blank">
                  {p?.headline}
                </a>
              </Box>
              <Box
                sx={{
                  fontSize: "0.875rem",
                  margin: "10px 0 2px 0",
                  color: "fontPrimaryColor.main",
                  fontFamily: "public sans",
                }}
              >
                Source: {p?.source}
              </Box>
              <Box
                sx={{
                  fontSize: "0.7rem",
                  color: "fontSecondaryColor.main",
                  fontFamily: "public sans",
                }}
              >
                {new Date(p?.date).toDateString()}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default PressReleases;
